import React from 'react';
import { Button,message } from 'antd';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import Sider from '../PlanSider';
import ExportUtil from '../../../common/ExportUtil';
import AdjustFte from './components/AdjustFte';
import TableC from '../../basicElement/TableC';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import AdjustSiteFtePlan from './components/AdjustSiteFtePlan.js';

class SiteFte extends React.Component {
    state = {
        sortParams: {},
        searchParams: {},
        data: [],
        loading: false,
        pagination: {
            pageSize: 11,
            current: 1,
        },
        total: {},
        isGivenSecondLines: false,  
        pendingCenterMonths: [],
    }

    componentDidMount() {
        const { siteId } = sessionStorage;
        if (siteId == 0) {
            this.loadData();
        } else {
            this.setState({
                searchParams: {
                    investigationSiteId: siteId,
                }
            }, () => {
                this.loadData();
            });
        }
        this.queryInvestigationStageByInvId();
        this.queryInvestigationSecondLines();
    }

    loadData = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            url: API_URL.plan.querySitePlanFte,
            data: {
                offset: current,
                limit: 10,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { data: { total, dataList: { datas, totalCount }, judgeInvThree} } = res;
                // let ct = Number((totalCount / (10)).toFixed(0)) + (totalCount % (10) > 0 ? 1 : 0);
                // pagination.total = totalCount + ct;

                pagination.total = Math.ceil(totalCount / (10)) * (judgeInvThree ? 12 : 11) ;

                pagination.pageSize = judgeInvThree ? 12 : 11;
                const months = datas ? (datas.filter(el => el.investigationSiteName === '待配置中心')[0] || {}).siteFtes : [];  //待配置中心的月份列表
                // 艾伯维-恶性肿瘤-202505150002（AR
                this.setState({
                    pagination,
                    loading: false,
                    data: datas,
                    total,
                    pendingCenterMonths: months,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination
        }, () => {
            this.loadData();
        });
    }

    calculateFte = () => {
        const { invId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.plan.sitePlanFteTaskTest,
            data: { invId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData();
            },
        };
        $.sendRequest(options);
    }

    export = () => {
        const { sortParams, searchParams, pagination } = this.state;
        ExportUtil.export({...sortParams, ...searchParams}, pagination, API_URL.plan.exportSitePlanFte);
    }

    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                });
            }
        };
        $.sendRequest(options);
    }

    queryInvestigationSecondLines = () => {
        //判断是否为执行业务线二级分类为“SSU主导、启动前协助、启动前协助+启动后常规CRC执行、启动后常规CRC执行、非盲”的项目
        const { invId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationSecondLines,
            data: { invId },
            dataType: 'json',
            doneResult: res => {
                const { secondLines, sitePlanFteCal } = res;
                const givenSecondLines = ['SSU主导','启动前协助','启动前协助+启动后常规CRC执行','启动后常规CRC执行','非盲'];
                const isGivenSecondLines = givenSecondLines.includes(secondLines) && sitePlanFteCal;
                this.setState({
                    isGivenSecondLines,
                });
            }
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }


    getColumns = () => {
        const { curRole } = sessionStorage;
        const { total, pendingCenterMonths } = this.state;
        const { siteFtes: monthList } = total || {};
        const list = (monthList || []).length !== 0 ? monthList : pendingCenterMonths;
        const shouldFixed = (list || []).length > 9;
        const columns = [{
            title: '序号',
            dataIndex: 'key',
            key: 'key',
            fixed: 'left',
            width: 60,
        }, {
            title: '中心编号',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            fixed: shouldFixed && 'left',
            width: shouldFixed && 100,
            sorter: true,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            fixed: shouldFixed && 'left',
            width: shouldFixed && 180,
            sorter: true,
        }, {
            title: '每月计划合计',
            dataIndex: 'monthtotal',
            key: 'monthtotal',
            fixed: shouldFixed && 'left',
            width: shouldFixed && 90,
            render: (text, record) => {
                const { isGivenSecondLines } = this.state;
                const { key, investigationSiteId } = record;
                return ((key !== "总计" && investigationSiteId != -1) && isGivenSecondLines )? <a onClick={() => this.adjustSiteFtePlanRef.show(record)}>{text}</a> : text
            }
        }];
        (list || []).forEach((item, index) => {
            const { title } = item;
            columns.push({
                title: title,
                dataIndex: title,
                key: title,
                width: shouldFixed && 60,
                render: (text, record) => {
                    const { isGivenSecondLines } = this.state;
                    const { siteFtes, ...rest } = record;
                    const siteFte = (siteFtes || [])[index] || {};
                    const { value, isUrl } = siteFte;
                    return (
                        (isUrl == "1" && (curRole == "PM" || curRole == "PA") && !isGivenSecondLines) ?
                            <a onClick={()=>this.canEditByInvStatus(() => this.adjustFte({...rest, ...siteFte}))}>{value}</a>
                        :
                            <span>{value}</span>
                    );
                }
            });
        });
        return columns;
    }

    getDataSource = () => {
        const { data, total, pagination } = this.state;
        const { current, pageSize } = pagination;
        const { siteId } = sessionStorage;
        const dataSource = (data || []).map((item, index) => {
            return {
                key: (current - 1) * pageSize + index + 1,
                ...item,
            };
        });
        if (siteId == 0) {
            const { siteFtes } = total || {};
            if (siteFtes) {
                dataSource.push({
                    key: "总计",
                    ...total,
                });
            }
        }
        return dataSource;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    handleChange = (option, key) => {
        const { searchParams } = this.state;
        const { text, value } = option;
        searchParams.investigationSiteId = value;
        searchParams.investigationSiteName = text;
        this.setState({ searchParams });
    }

    adjustFte = (record) => {
        this.fteRef.show(record);
    }

    render() {
        const { loading, pagination, sortParams, searchParams: { investigationSiteName }, invStageList, isGivenSecondLines } = this.state;
        const { siteId, curRole } = sessionStorage;
        return (
            <div className="content fte_plan">
                <Sider />
                <div className="main">
                    <div className="breadcrumb-bar tac">
                        <h2 className="title">
                            {siteId == 0 ? "各中心FTE计划" : "中心FTE计划"}
                        </h2>
                    </div>
                    <div className="search-bar bar2" style={{marginBottom: 20}}>
                        {
                            siteId == 0 &&
                            <div className="search-item">
                                <label htmlFor="" className="ui-label">中心编号/中心名称</label>
                                <SearchRetrieve
                                    keyword='searchKey'
                                    style={{ width: 200 }}
                                    placeholder="输入中心编号/名称检索"
                                    value={investigationSiteName}
                                    params={{ limit: 20 }}
                                    url={API_URL.site.list}
                                    config={{ id: 'investigationSiteId', name: 'investigationSiteName', code: 'investigationSiteCode', type: 'site', show: 'site' }}
                                    onChange={option => this.handleChange(option, 'investigationSite')}
                                />
                            </div>
                        }
                        <div className="search-item">
                            {siteId == 0 && <Button type="primary" onClick={this.search}>搜索</Button>}
                            <Button type="primary" onClick={this.export}>导出</Button>
                            {siteId == 0 && curRole == 'PM' && isGivenSecondLines && <Button type="primary" onClick={this.calculateFte}>计划FTE计算</Button>}
                        </div>
                    </div>
                    <TableC
                        loading={loading}
                        sortParams={sortParams}
                        columns={this.getColumns()}
                        data={this.getDataSource()}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                    />
                    <AdjustFte ref={el => this.fteRef = el} loadData={this.loadData} invStageList={invStageList} />
                    <AdjustSiteFtePlan ref={el => this.adjustSiteFtePlanRef = el} loadData={this.loadData} />
                </div>
            </div>
        );
    }
}

export default SiteFte;


// WEBPACK FOOTER //
// ./src/components/plan/siteFte/index.js